import React from "react";
import Moment from "react-moment";

function Comments(props) {
  const { comment, deleteComment } = props;

  return (
    <div className="comments">
      <p>{comment.commentBody}</p>
      <span>
        <Moment date={comment.createDate} format="lll" />
        <button onClick={() => deleteComment(comment.id)}>delete</button>
      </span>
    </div>
  );
}

export default Comments;
